/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseListString
 */
export interface ResponseListString {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListString
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListString
     */
    message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseListString
     */
    data?: Array<string>;
}

/**
 * Check if a given object implements the ResponseListString interface.
 */
export function instanceOfResponseListString(value: object): value is ResponseListString {
    return true;
}

export function ResponseListStringFromJSON(json: any): ResponseListString {
    return ResponseListStringFromJSONTyped(json, false);
}

export function ResponseListStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListString {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseListStringToJSON(json: any): ResponseListString {
    return ResponseListStringToJSONTyped(json, false);
}

export function ResponseListStringToJSONTyped(value?: ResponseListString | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

